<template>
  <div class="ProjectLayout" data-locator="project-settings-page">
    <h1 class="pb-4 ml-1">{{ $t("project.project-settings.layouts.ProjectLayout.projectSettings") }}</h1>
    <p class="pb-4 ml-1 text-body-1 text-accent-lighten-2">
      {{ $t("project.project-settings.layouts.ProjectLayout.configureYourProject") }}
      <AppInfoTooltip>
        <p class="mb-0">{{ $t('project.project-settings.layouts.ProjectLayout.projectSettingsInfo1') }}</p>
        <p class="mb-0">{{ $t('project.project-settings.layouts.ProjectLayout.projectSettingsInfo2') }}</p>
      </AppInfoTooltip>
    </p>
    <ProjectSettingsMainSettings :mnemo="roomMnemo"/>
    <ProjectSettingsAccessRights class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsFeatures v-if="allowValidationChecklistItemDeletion" class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsInformation class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsSignatures class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsNotifications class="mt-8" :mnemo="roomMnemo"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppInfoTooltip from '@/common/AppInfoTooltip.vue'
import ProjectSettingsNotifications from '@/project/project-settings/notifications/ProjectSettingsNotifications.vue'

import ProjectSettingsAccessRights from '../access-rights/AccessRights.vue'
import ProjectSettingsFeatures from '../ProjectSettingsFeatures.vue'
import ProjectSettingsInformation from '../ProjectSettingsInformation.vue'
import ProjectSettingsMainSettings from '../ProjectSettingsMainSettings.vue'
import ProjectSettingsSignatures from '../signatures/ProjectSettingsSignatures.vue'

export default {
  name: 'ProjectLayout',
  components: {
    AppInfoTooltip,
    ProjectSettingsAccessRights,
    ProjectSettingsFeatures,
    ProjectSettingsInformation,
    ProjectSettingsMainSettings,
    ProjectSettingsNotifications,
    ProjectSettingsSignatures,
  },
  computed: {
    ...mapGetters('room', ['allowValidationChecklistItemDeletion', 'roomMnemo']),
  },
}
</script>
